import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../../DataGridFlexSales';

import { reportFilterCountryCodeSelector, reportSalesJournalNcsSelector } from '../../../state';
import handlerFactory, { NcsDataGridContext } from './handlerFactory';
import { SalesJournalNcs } from '../../../types';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<SalesJournalNcs, NcsDataGridContext>();

  const { t } = useTranslation();
  const title = t('sales-journal.title');
  const country = useSelector(reportFilterCountryCodeSelector);
  const gcsResource = useSelector(reportSalesJournalNcsSelector);

  const { data, loading } = gcsResource;

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
  });

  return null;
};

const NcsDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory} hideToolbar>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default NcsDataGrid;
